import React from "react";
import Breadcrumb from "./Breadcrumbs";
import useBreadcrumbs from "@elevio/kb-kit/lib/hooks/useBreadcrumbs";

type Props = {
  className?: string;
};

const PageBreadcrumb: React.FC<Props> = ({ className }) => {
  const crumbs = useBreadcrumbs();
  return <Breadcrumb className={className} crumbs={crumbs} />;
};

export default PageBreadcrumb;
